import API from "serviceshift-ui/api-client";

const BASE_URL = "/admin/v4/custom_form_templates";

// Single data layer for custom form templates, shared by the library and the
// builder. Actions return the parsed template so callers can adopt the
// server's tree (with freshly assigned section/question ids) as source of
// truth after each save. Errors reject and are flashed by the global
// interceptor.
export default {
  fetchCustomFormTemplate({ commit }, id) {
    return API.makeRequest(`${BASE_URL}/${id}`, { method: "GET" }).then(
      (res) => {
        commit("replace", {
          state: "currentCustomFormTemplate",
          data: res.data
        });
        return res.data;
      }
    );
  },
  createCustomFormTemplate(_, template) {
    // ignoreError: the builder owns save-error display (it maps the 422 errors
    // hash to inline field messages), so we suppress the interceptor's generic
    // toast that would otherwise read "unexpected error" for a validation fail.
    return API.makeRequest(BASE_URL, {
      method: "POST",
      data: { custom_form_template: template },
      headers: { ignoreError: true }
    }).then((res) => res.data);
  },
  updateCustomFormTemplate(_, { id, template }) {
    return API.makeRequest(`${BASE_URL}/${id}`, {
      method: "PUT",
      data: { custom_form_template: template },
      headers: { ignoreError: true }
    }).then((res) => res.data);
  },
  publishCustomFormTemplate(_, id) {
    return API.makeRequest(`${BASE_URL}/${id}/publish`, {
      method: "PUT"
    }).then((res) => res.data);
  },
  archiveCustomFormTemplate(_, id) {
    return API.makeRequest(`${BASE_URL}/${id}/archive`, {
      method: "PUT"
    }).then((res) => res.data);
  },
  unarchiveCustomFormTemplate(_, id) {
    return API.makeRequest(`${BASE_URL}/${id}/unarchive`, {
      method: "PUT"
    }).then((res) => res.data);
  },
  duplicateCustomFormTemplate(_, id) {
    return API.makeRequest(`${BASE_URL}/${id}/duplicate`, {
      method: "POST"
    }).then((res) => res.data);
  },
  destroyCustomFormTemplate(_, id) {
    return API.makeRequest(`${BASE_URL}/${id}`, { method: "DELETE" });
  }
};
